import { ProgressPromise } from '@prezly/progress-promise';
export function toProgressPromise(filePromise) {
  return new ProgressPromise((resolve, reject, progress) => {
    filePromise.then(resolve, reject);
    filePromise.progress(uploadInfo => {
      progress(uploadInfo.progress * 100, uploadInfo);
    });
  });
}